import WeMoveAlong from "../../../../src/components/blackout-poems/we-move-along";
import * as React from 'react';
export default {
  WeMoveAlong,
  React
};